
import {SET_TAXES} from '../actions/taxes';
const initialState = {
    percent: null
};
const taxes = (state = initialState, action) => {
    switch(action.type)
    {
        case SET_TAXES : 
        return {percent: action.payload.tax1_percent + action.payload.tax2_percent};
        default:
        return state;
    }
};

export default taxes;


// WEBPACK FOOTER //
// ./src/store/reducers/taxes.js